@if ((flagService.getFlags$() | async)?.[FeatureFlags.IMAGE_GALLERY]) {
    <div [matTooltip]="getToolTip()" matTooltipPosition="right">
        <button
                matIconButton
                id="dock-gallery-toolbar-button"
                class="mat-icon-toggle-button"
                [disabled]="!enabledPanel" type="button" [class.selected]="displayPanel"
                (click)="togglePanelDisplay()">
            <mat-icon svgIcon="satellite"></mat-icon>
        </button>
    </div>
}
<div
    #galleryPanel
    id="gallery-panel-container"
    [class]="!displayPanel && !isCollapsed ? 'd-none' : 'visible'"
    [ngClass]="{
      'toolbar-panel-container': true,
      'collapse-line': isCollapseButtonShown || isCollapsed,
      collapsed: isCollapsed,
      'hide-container-scroll': true
    }">
    <div class="toolbar-header-wrapper">
        <div class="toolbar-gallery-header">
            <h6>Image Gallery</h6>
            <button matButton (click)="openDialogGallery()">Fullscreen mode</button>
            <div
                    [ngClass]="{
            'collapse-button': true,
            collapsed: isCollapsed
          }"
                    (mouseenter)="switchBoolValue('isCollapseButtonShown', true)"
                    (mouseleave)="switchBoolValue('isCollapseButtonShown', false)">
                @if (isCollapseButtonShown || isCollapsed) {
                    <mat-icon
                              (click)="toggleGalleryCollapsingState(!isCollapsed)">
                        {{ isCollapsed ? "arrow_right" : "arrow_left" }}
                    </mat-icon>
                }
            </div>
        </div>
    </div>
    @if (this.enableDebugOptions) {
        <div>
            <button matButton color="primary" [disabled]="!status" (click)="paintStatus()">Show Status</button>
        </div>
    }
    <div class="toolbar-gallery-info-panel" [hidden]="isCollapsed">
        <div class="info-block-wrapper">
            @if (filteredImages?.length) {
                <span class="image-amount small-info-text">{{ filteredImages.length }}
                    images</span>
            } @else {
                <div class="image-gallery-message mat-card" id="image-gallery-message">No
                    available images at this location.
                </div>
            }
            @if (selectedCollection) {
                <div class="year-selector">
                    <mat-form-field class="form-ultra-slim w-100">
                        <mat-select
                                [value]="selectedCollection.year"
                                #collectionSelect
                                (selectionChange)="selectCollection($event)">
                            @for (collection of collections; track collection.year) {
                                <mat-option [value]="collection.year">
                                    {{ collection.year }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            }

        </div>
        <div class="filters-scroll-block" [hidden]="!selectedCollection">
            @if (showLeftScroll) {
                <button matIconButton class="scroll-arrow" id="left-arrow"
                        (click)="slideScroll('left')">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
            }
            @if (showRightScroll) {
                <button matIconButton class="scroll-arrow" id="right-arrow"
                        (click)="slideScroll('right')">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
            }
            <div class="filter-wrapper" #filterContainer id="filter-container" (scroll)="onScroll()">
                <div class="image-filters" #filterButtons>
                    @if (visibleLayers?.length) {
                        <mat-button-toggle-group
                                [hideMultipleSelectionIndicator]="true"
                                multiple
                                class="filter-group"
                                name="categories"
                                [value]="[selectedFilter.layername]"
                                (change)="changeCategory($event)"
                                aria-label="Image category">
                            @if (visibleLayers.includes('bluesky') || visibleLayers.includes('urban')) {
                                <mat-button-toggle [class.locked]="categoryLocked()" value="bluesky">
                                    Blue Sky
                                </mat-button-toggle>
                            }
                            @if (visibleLayers.includes('vdp')) {
                                <mat-button-toggle [class.locked]="categoryLocked()"
                                                   value="vdp">VDP
                                </mat-button-toggle>
                            }
                            @if (visibleLayers.includes('graysky')) {
                                <mat-button-toggle [class.locked]="categoryLocked()"
                                                   value="graysky">Gray Sky
                                </mat-button-toggle>
                            }
                        </mat-button-toggle-group>
                    }
                    @if (visibleResolutions?.length) {
                        <mat-button-toggle-group
                                [hideMultipleSelectionIndicator]="true"
                                multiple
                                class="filter-group"
                                name="resolutions"
                                [value]="[selectedFilter.resolution]"
                                (change)="changeResolution($event)"
                                aria-label="Image resolution">
                            @if (visibleResolutions.includes('ultra')) {
                                <mat-button-toggle [class.locked]="resolutionLocked()" value="ultra">Urban</mat-button-toggle>
                            }
                            @if (visibleResolutions.includes('high')) {
                                <mat-button-toggle [class.locked]="resolutionLocked()" value="high">Wide Area</mat-button-toggle>
                            }
                        </mat-button-toggle-group>
                    }
                    @if (visibleOrientations?.length) {
                        <mat-button-toggle-group
                            multiple
                            [hideMultipleSelectionIndicator]="true"
                            class="filter-group"
                            [value]="[selectedFilter.orientation]"
                            (change)="changeOrientation($event)"
                            aria-label="Image orientation">

                            @if (visibleOrientations.includes('N*')) {
                                <mat-button-toggle value="N*">Vertical</mat-button-toggle>
                            }
                            @if (visibleOrientations.includes('N')) {
                                <mat-button-toggle value="N">North</mat-button-toggle>
                            }
                            @if (visibleOrientations.includes('S')) {
                                <mat-button-toggle value="S">South</mat-button-toggle>
                            }
                            @if (visibleOrientations.includes('E')) {
                                <mat-button-toggle value="E">East</mat-button-toggle>
                            }
                            @if (visibleOrientations.includes('W')) {
                                <mat-button-toggle value="W">West</mat-button-toggle>
                            }
                    </mat-button-toggle-group>
                    }
                </div>
            </div>
        </div>
    </div>
    @if (this.selectedCollection) {
        <div class="toolbar-gallery-container" #galleryContainer id="gallery-container" >
            @for (image of filteredImages; track image.image_id) {
                <phoenix-gallery-image
                        [ngClass]="this.obliqueAvailable ? 'docked-image' : ''"
                        [enableDebugOptions]="enableDebugOptions"
                        [isSelected]="selectedImage && selectedImage.image_id === image.image_id"
                        [attr.image-id]="image.image_id"
                        [image]="image"
                        [mode]="this.mode"
                        [galleryService]="this.galleryService"
                        (click)="this.obliqueAvailable ? viewOnMap($event, image) : ''"></phoenix-gallery-image>
            }
        </div>
    }

</div>
